import { INavStyles, IStyle, mergeStyleSets, mergeStyles } from "@fluentui/react";
import { IM365Theme } from "@m365-admin/customizations";
export const menuStyles: Partial<INavStyles> = {
  root: {
    height: "100%!important",
    boxSizing: "border-box",
    borderRight: "1px solid #e1dfdd",
    backgroundColor: "#f3f2f1",
    overflowY: "auto",
    paddingLeft: "0px"
  },
  chevronButton: {
    right: "1px!important",
    left: "auto"
  }
};

export const menuContainerStyles = mergeStyleSets({
  "menuContainer": {
    width: "200px",
    ">div": {
      height: "100%"
    }
  }
});

export const M365NavMainStyle = mergeStyles({ display: "flex", height: "100%", background: "#fff" });

export interface IResponsiveNavStyleProps {
  theme: IM365Theme;
  reduceMargins: boolean;
  isNavInOverlay: boolean;
}

export interface IResponsiveNavStyles {
  root: IStyle;
  header: IStyle;
  headerText: IStyle;
  main: IStyle;
  contentContainer: IStyle;
  contentNav: IStyle;
  content: IStyle;
  navWrapper: IStyle;
  navContainer: IStyle;
}

export const getResponsiveNavStyles = (
  props: IResponsiveNavStyleProps,
): IResponsiveNavStyles => {
  const { theme, isNavInOverlay, reduceMargins } = props;
  const headerHeight = 50;

  return {
    root: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff"
    },
    header: {
      flex: `0 0 ${headerHeight}px`,
      background: "#333",
      color: theme.semanticColors.alwaysWhite,
      lineHeight: headerHeight,
    },
    headerText: { margin: "0px 16px" },
    main: {
      display: "flex",
      overflow: "hidden",
      flexBasis: `calc(100% - ${headerHeight}px)`,
      flexGrow: 0,
      flexShrink: 0,
      position: "relative",
    },
    contentContainer: {
      flex: "1 1 auto",
      background: theme.semanticColors.bodyBackground,
      overflowY: "auto",
    },
    contentNav: {
      minHeight: 48,
      borderBottom: isNavInOverlay
        ? undefined
        : `solid 1px ${theme.semanticColors.primaryDividerLine}`,
      margin: isNavInOverlay ? undefined : "0px 48px",
      background: theme.semanticColors.bodyBackground,
      ...(isNavInOverlay && { position: "sticky", top: 0 }),
    },
    content: {
      /**
       * Generally, something like this should be handled as a media query. For this example we didn't do that because
       * our samples are rendered within another app. Thus, if we used media queries the rendered output within the
       * demo site would be incorrect. Within your app feel free to just use CSS media queries to handle this.
       */
      padding: reduceMargins ? "0px 24px" : "0px 48px",
    },
    navWrapper: {
      position: "absolute",
      height: "100%",
      background: theme.semanticColors.bodyBackground,
      top: 0,
      "div": {
        backgroundColor: "#FFF!important",
      }
    },
    navContainer: {
      backgroundColor: "#FFF!important",
    }
  };
};
